import { useTranslation } from 'react-i18next'
import { Download } from 'lucide-react'

export function IntelExportButton() {
  const { t } = useTranslation('intel')

  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="print-hide inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-ring"
    >
      <Download size={14} />
      {t('export.pdf')}
    </button>
  )
}
